// extracted by mini-css-extract-plugin
export default {"cls1":"VeloChip-StyledChip_cls1__AqiK+","cls2":"VeloChip-StyledChip_cls2__ixuFV VeloChip-StyledChip_cls1__AqiK+"};